import { VolumePricingMode, ScalingRegion, ScaleDataSource } from '@/utils/Enumerations'
import { utcToLocalDate } from '@/utils/DateFormatter'
import { lowerCase, startCase } from 'lodash'

const getRegionNameFromScaleDataResponse = (regionString) => {
  let regionEnum = ScalingRegion.Unknown
  switch (regionString) {
    case 'REGION1':
      regionEnum = ScalingRegion.Region1; break
    case 'REGION4':
      regionEnum = ScalingRegion.Region4; break
    case 'REGION5':
      regionEnum = ScalingRegion.Region5; break
    case 'REGIONE6':
      regionEnum = ScalingRegion.RegionE6; break
    case 'REGIONW6':
      regionEnum = ScalingRegion.RegionW6; break
  }
  return regionEnum.name
}

const scaleDataInfoItems = [
  {
    label: 'ext2',
    key: 'ext2',
    value: (i) => i
  },
  {
    label: 'scaledBy',
    key: 'scaledByUser',
    value: (i) => i
  },
  {
    label: 'scaledAt',
    key: 'scaledAt',
    value: (i) => utcToLocalDate(i, 'L - LT')
  },
  {
    label: 'scaleRule',
    key: 'scaleRuleName',
    value: (i) => startCase(lowerCase(i))
  },
  {
    label: 'pricingMode',
    key: 'volumePricingMode',
    value: (i) => VolumePricingMode.fromInt(i)
  },
  {
    label: 'region',
    key: 'regionName',
    value: getRegionNameFromScaleDataResponse
  }
]

export function formatScaleDataInfo (scaleData, scaleDataSource, ext2) {
  const formattedScaleData = {}
  formattedScaleData.ext2 = ext2
  scaleDataInfoItems.forEach((item) => {
    if (item.key === 'scaledAt') {
      switch (scaleDataSource) {
        case ScaleDataSource.Expansion.value:
          item.label = 'expandedAt'
          break
        case ScaleDataSource.Imported.value:
          item.label = 'importedAt'
          break
        default:
          item.label = 'scaledAt'
          break
      }
    }
    if (scaleData[item.key] !== undefined) {
      formattedScaleData[item.label] = item.value(scaleData[item.key])
    }
  })
  formattedScaleData.scaleDataSource = scaleDataSource
  return formattedScaleData
}
